import { store, history } from '../store.js';
var jwtDecode = require('jwt-decode');

export function authHeader() {
  // return authorization header with jwt token
  //console.log('auth header being called');
  //console.log(localStorage.getItem('user'));
  let user = '';
  user = JSON.parse(localStorage.getItem('user'));

  if (user && user.access_token) {
    return 'Bearer ' + user.access_token;
  } else {
    return {};
  }
}

export function scenarioHeader() {
  let scenario = store.getState().scenario;
  console.log(store.getState().scenario);
  //scenario.scenario_id ? return scenario.scenario_id : return null;
  if (scenario.selectedScenario) {
    return scenario.selectedScenario;
  } else {
    return '';
  }
}

export const requestOptions = () => {
  return {
    headers: {
      Authorization: authHeader(),
      'Selected-Scenario': scenarioHeader()
    }
  };
};

export const jwtInfo = () => {
  var decoded = jwtDecode(localStorage.getItem('user'));
  return decoded;
};

export const jwtTeam = () => {
  var decoded = jwtDecode(localStorage.getItem('user'));
  return decoded.identity.team;
};



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js